export default {
  'account:subscription:execute-now-confirmation:info-card:total-label': 'Gesamtbetrag inkl. MwSt',
  'account:subscription:execute-now-confirmation:info-card:delivery-date-label':
    'Voraussichtliches Lieferdatum',
  'account:subscription:execute-now-confirmation:info-card:delivery-date-pending': 'Wird berechnet',
  'account:subscription:deliver-ondemand:oos:badge': 'Ausverkauft',
  'account:subscription:deliver-ondemand:success-toast':
    'Deine Bestellung wird noch heute bearbeitet!',
  'account:subscription:price-summary:shipping-price': '* CHF',
  'account:subscription:price-summary:shipping-info':
    '*<b>Lieferkosten</b> werden bei jeder Bestellung neu berechnet. Kostenlos Lieferung ab CHF 100.',
};
